export const LOAD_MANAGER_FEEDBACK_ON_REPORT_QUESTIONNAIRE = "LOAD_MANAGER_FEEDBACK_ON_REPORT_QUESTIONNAIRE";
